import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import Header from './Header';

import { actions as modalActions } from 'modules/modal';
import { actions, selectors } from 'modules/user';

class HeaderContainer extends PureComponent {
  showHelp = () => {
    const { showModal } = this.props;
    showModal('help');
  };

  render() {
    return <Header showHelp={this.showHelp} {...this.props} />;
  }
}

const mapStateToProps = state => ({
  user: selectors.user(state),
  isLoggedIn: selectors.isLoggedIn(state),
});

export default connect(mapStateToProps, {
  onLoginFacebook: actions.loginFacebook,
  onLoginGoogle: actions.loginGoogle,
  onLogout: actions.logout,
  showModal: modalActions.showModal,
})(HeaderContainer);



// WEBPACK FOOTER //
// ./src/components/Header/Header.container.js